import { render, staticRenderFns } from "./cards.component.vue?vue&type=template&id=64eddfe5"
import script from "./cards.component.vue?vue&type=script&lang=js"
export * from "./cards.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports